/**
* ValidationServices
*/

var Validation = {
    cardExpiryDate: /^([0-9]{1,2}\/[0-9]{4})$/,
    email: /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]+)$/,
    name: /^(.*?)$/,

    isValidCardExpiryDate: function(expiryDate) {
        return this.cardExpiryDate.test(expiryDate);
    },

    isValidFirstLastName: function(names) {
        // return this.name.test(names);
        return true;
    },

    isValidEmail: function(email) {
        return this.email.test(email);
    }
};

/**
* FormValidation
*/
var FormValidationRules = {
    IS_NUMBER: function(value) {
        return typeof value == 'number';
    },

    LENGTH_IN_RANGE: function(value, param) {
        return $.trim(value).length >= param.min && $.trim(value).length <= param.max;
    },

    MAX_LENGTH: function(value, maxLength) {
        return $.trim(value).length <= maxLength;
    },

    MIN_LENGTH: function(value, minLength) {
        return $.trim(value).length >= minLength;
    },

    NUMBER_IN_RANGE: function(value, param) {
        return parseInt(value) >= param.min && parseInt(value) <= param.max;
    },

    REQUIRED: function(value) {
        return $.trim(value).length > 0;
    },

    VALID_EMAIL: function(value) {
        return Validation.isValidEmail(value);
    }
};

class FormValidation {
    constructor(form) {
        if(!form || !form.length) {
            throw new Error('Insufficient arguments');
            return;
        }

        this.form = form;
        this.errors = [];
        this.validationRules = [];

        this.errorsHandler = null;
        this.successHandler = null;

        this.initForm();
    }

    initForm() {
        var that = this;

        this.form.bind('submit', function() {
            if(!that.validate()) {
                if(that.errorsHandler) {
                    that.errorsHandler(that.errors);
                }

                return false;
            }
            else {
                if(that.successHandler) {
                    that.successHandler();
                    return true;
                }
            }
        });
    }

    addRule(target, rule, param, errorMessage) {
        if(!target || !target.length || !rule) return;

        var ruleFunction;
        var ruleFunctionParam;

        if(typeof rule == 'function') {
            ruleFunction = rule;
            ruleFunctionParam = param;
        }
        else {
            if(typeof FormValidationRules[rule] == 'function') {
                ruleFunction = FormValidationRules[rule];
                ruleFunctionParam = param;
            }
        }

        if(ruleFunction) {
            this.validationRules.push({
                target: target,
                rule: ruleFunction,
                param: ruleFunctionParam,
                error: errorMessage
            });
        }
        else {
            throw new Error('Rule not found');
        }
    }

    validate() {
        this.errors = [];

        for(var i = 0; i < this.validationRules.length; i++) {
            if(!this.validationRules[i].rule(this.validationRules[i].target.val(), this.validationRules[i].param)) {
                this.errors.push({
                    target: this.validationRules[i].target,
                    error: this.validationRules[i].error,
                    value: this.validationRules[i].target.val()
                });
            }
        }

        return (this.errors.length) ? false : true;
    }
}

export { Validation, FormValidationRules, FormValidation }
